<template>
  <div>
    <popup ref="popup" :loading="popupLoading">
      <div slot="body">
        <el-form class="dataForm" ref="form" :disabled="disabled" :model="tstPlan" inline label-width="150px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="字符 - 含义" prop="level">
                <el-select v-model="charMean" placeholder="请选择">
                  <el-option v-for="(itm, index) in charMeanOptions" :key="index"
                    :label="`${index + 1}. ${itm.char} : ${itm.mean}`" :value="itm.char" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态查询" prop="status">
                <el-select placeholder="全部" v-model="status" @change="list" :disabled="!notEdit">
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="待修正" value="1"></el-option>
                  <el-option label="处理中" value="2"></el-option>
                  <el-option label="已完成" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-button size="mini" type="danger" @click="toEditSubs" v-show="!status || status === '0'">{{ toEditTxt
              }}</el-button>

              <!-- 导出Excel 按钮：维护状态和status!=0时隐藏 -->
              <el-button size="mini" type="success" @click="exportExcel"
                v-show="notEdit && (!status || status === '0')">导出Excel</el-button>

              <el-button size="mini" @click="toAddSubs" type="warning" v-show="!notEdit">加一行</el-button>
              <el-button size="mini" type="success" v-show="!notEdit" @click="submit">完成编辑</el-button>

              <!-- 全选 按钮：只在status=1时显示 -->
              <el-button size="mini" type="success" @click="allchoose" v-show="status == 1">全选</el-button>

              <!-- 生成Sprint待办 按钮：只在有选择时显示 -->
              <el-button size="mini" type="danger" @click="toaddsprint" v-show="hasCheckedItems">生成Sprint待办</el-button>


            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-table :data="subjects || []" style="width: 100%">

                <!-- 勾选框 只在status=1时显示 -->
                <el-table-column label="选择" width="50" align="center" v-if="status === '1'">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.checked" size="big"></el-checkbox>
                  </template>
                </el-table-column>

                <el-table-column prop="caseno" label="测试编号" width="200">
                  <template slot-scope="scope">
                    <el-input size="mini" :disabled="notEdit" v-model="scope.row.caseno"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="title" label="测试标题" width="300">
                  <template slot-scope="scope">
                    <el-input size="mini" type="textarea" rows="1" :disabled="notEdit"
                      v-model="scope.row.title"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="module" label="测试模块" width="180">
                  <template slot-scope="scope">
                    <el-input size="mini" type="textarea" rows="1" :disabled="notEdit"
                      v-model="scope.row.module"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="priority" label="优先级（1低2中3高）" width="170">
                  <template slot-scope="scope">
                    <el-select size="mini" v-model="scope.row.priority" :disabled="notEdit" placeholder="请选择优先级"
                      style="width:100%">
                      <el-option label="1" value="1"></el-option>
                      <el-option label="2" value="2"></el-option>
                      <el-option label="3" value="3"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column prop="preconditions" label="预置条件" width="120">
                  <template slot-scope="scope">
                    <el-select size="mini" v-model="scope.row.preconditions" placeholder="请选择" :disabled="notEdit"
                      style="width:100%">
                      <el-option v-for="(item, index) in charMeanOptions" :key="index" :label="item.char"
                        :value="item.char"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column prop="executeData" label="执行数据" width="300">
                  <template slot-scope="scope">
                    <el-input size="mini" type="textarea" rows="1" :disabled="notEdit"
                      v-model="scope.row.executeData"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="executionSteps" label="执行步骤" width="300">
                  <template slot-scope="scope">
                    <el-input size="mini" type="textarea" rows="1" :disabled="notEdit"
                      v-model="scope.row.executionSteps"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="expectedResult" label="预期结果" min-width="300">
                  <template slot-scope="scope">
                    <el-input size="mini" type="textarea" rows="1" :disabled="notEdit"
                      v-model="scope.row.expectedResult"></el-input>
                  </template>
                </el-table-column>

                <el-table-column prop="actualResult" label="实际结果" width="300">
                  <template slot-scope="scope">
                    <el-input size="mini" type="textarea" rows="1" :disabled="notEdit"
                      v-model="scope.row.actualResult"></el-input>
                  </template>
                </el-table-column>

                <!-- 状态（1待修正 2处理中 3已完成） -->
                <el-table-column prop="state" label="状态" width="170">
                  <template slot-scope="scope">
                    <el-select size="mini" v-model="scope.row.state" :disabled="notEdit" placeholder="请选择状态"
                      style="width:100%">
                      <el-option label="待修正" value="1"></el-option>
                      <el-option label="处理中" value="2"></el-option>
                      <el-option label="已完成" value="3"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <!-- 图片/截图 -->
                <el-table-column prop="screenshot" label="截图" width="160">
                  <template slot-scope="scope">
                    <el-button size="mini" type="primary" :disabled="notEdit" @click="openImageDrawer(scope.row)">
                      上传图片
                    </el-button>
                    <!-- <div v-if="scope.row.screenshot" style="margin-top:5px;font-size:12px;color:#666;">
                      <a v-for="(itm, idx) in scope.row.screenshot" :key="itm" :href="serverUrl + itm" target="_blank">
                        查看第 {{ idx + 1 }} 张<br>
                      </a>
                    </div> -->

                    <!-- 判断数组类型 -->
                    <div v-if="scope.row.screenshot && Array.isArray(scope.row.screenshot)"
                      style="margin-top:5px;font-size:12px;color:#666;">
                      <a v-for="(itm, idx) in scope.row.screenshot" :key="itm" :href="serverUrl + itm" target="_blank">
                        查看第 {{ idx + 1 }} 张<br>
                      </a>
                    </div>

                  </template>
                </el-table-column>

                <el-table-column label="操作" width="80" v-if="!notEdit">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="delSub(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="close">关 闭</el-button>
      </div>
    </popup>

    <!-- 右侧抽屉：多图上传 -->
    <el-drawer title="上传图片" :visible.sync="imageDrawerVisible" direction="rtl" size="520px">
      <div style="padding: 20px">
        <file-upload v-model="currentImage" model="base64" uri="/statics/tst" :size="2048" @change="onFileSelect" />

        <!-- 预览所有已上传图片 -->
        <div style="display: flex;flex-wrap: wrap;margin-top:20px;">
          <div v-for="(img, idx) in previewImages" :key="idx"
            style="width:100px;height:100px;margin:5px;position:relative;">
            <img :src="img" style="width:100%;height:100%;object-fit:cover;border-radius:6px;">
            <el-button type="danger" icon="el-icon-delete" size="mini" style="position:absolute;bottom:0;right:0;"
              @click="deleteImg(idx)"></el-button>
          </div>
        </div>
      </div>

      <div style="text-align:right;padding:15px 20px;border-top:1px solid #eee;">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="saveImgsToRow">确定保存</el-button>
      </div>
    </el-drawer>

    <!-- 选择Sprint，居中弹窗 -->
    <dialog-popup ref="sprintDialog" :loading="sprintDialogLoading">
      <div slot="body">
        <el-form class="dataForm" ref="sprintForm" :model="sprintForm" inline label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="选择Sprint" prop="sprintId">
                <el-select v-model="sprintForm.sprintId" placeholder="请选择Sprint" style="width: 100%">
                  <el-option v-for="item in sprintList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="closeSprintDialog">取 消</el-button>
        <el-button type="primary" @click="confirmSprint">确 定</el-button>
      </div>
    </dialog-popup>
    <!-- 右下角自动保存倒计时 -->
    <div v-if="countdownVisible" class="autosave-wrapper">

       <div class="autosave-circle">

        <svg width="60" height="60" viewBox="0 0 60 60">
        <circle cx="30" cy="30" r="26" stroke="#e0e0e0" stroke-width="4" fill="none"/>
        <circle cx="30" cy="30" r="26" stroke="#409EFF" stroke-width="4" fill="none"
          :stroke-dasharray="circleDasharray"
          :stroke-dashoffset="circleDashoffset"
          stroke-linecap="round"
          transform="rotate(-90 30 30)"/>
      </svg>
      <span class="autosave-text">{{ countdown }}s</span>

       </div>
      <el-button 
      type="primary" 
      size="small" 
      icon="el-icon-download" 
      @click="manualSaveDraft"
      class="manual-save-btn">
      暂存
    </el-button>
</div> 
<!-- 调用Sprint编辑页面 -->
  <sbledit ref="edit" :selectProd="selectProd" :sprintId="sprintId" @success="handleSuccess"></sbledit>
  </div>
</template>

<script>
import sbledit from "@/views/sprint/sprint_backlog/edit.vue";

import popup from "@/components/popup/drawerPopup.vue";
import dialogPopup from "@/components/popup/dialogPopup.vue";
import fileUpload from "@/components/biz/fileUpload/fileUpload.vue";
import api from '@/api/product/tst/testcase/testcase.js';
import constant from '@/util/constant.js';
import apiTeamMember from "@/api/team/teamMember/teamMember.js";
import apiSprintBacklog from "@/api/sprint/sprintBacklog/sprintBacklog.js";
import { forEach } from "lodash";

export default {
  components: {
    popup,
    dialogPopup,
    fileUpload,
    sbledit,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      tstPlan: {},
      subjects: [],
      subjectsBackup: [],
      toEditTxt: "维护用例",
      notEdit: true,
      charMeanOptions: [],
      charMean: "",

      // 图片上传相关
      imageDrawerVisible: false,
      currentRow: null,
      currentImage: "",
      previewImages: [],
      oldImgList: [],
      serverUrl: constant.serverUrl,
      baseURI: constant.serverUrl,

      status: "0",

      // Sprint选择相关
      sprintDialogLoading: false,
      sprintList: [],
      sprintForm: {
        sprintId: ''
      },

      // 传递给edit组件的参数
      selectProd: '',
      sprintId: '',

      // 自动保存相关
      autoSaveTimer: null,        // 定时器 id
      countdown: 30,              // 当前倒计时秒数
      countdownVisible: false,    // 是否显示倒计时圆圈
      countdownStarted: false,    // 是否已经启动过（防止重复启动）
      circleTotal: 30,            // 总秒数

      loadingFlag: false,
    };
  },

  computed: {
    // 判断是否有选中项
    hasCheckedItems() {
      if (!this.subjects || this.subjects.length === 0) {
        return false;
      }
      return this.subjects.some(item => item.checked === true);
    },
          // 圆圈周长（2πr，r=26）
    circleDasharray() {
        return 2 * Math.PI * 26;
      },
      // 根据倒计时计算 offset
    circleDashoffset() {
        const total = 2 * Math.PI * 26;
        const ratio = this.countdown / this.circleTotal;
        return total * (1 - ratio);
      }


  },
  watch: {
  subjects: {
    handler() {
      this.onUserInput();
    },
    deep: true
  }
},
  methods: {

    // 打开图片抽屉
    openImageDrawer(row) {

      this.currentRow = row;
      this.previewImages = [];
      this.oldImgList = [];

      //   if (row.screenshot) {
      //     this.oldImgList = row.screenshot.split(",");
      //     this.previewImages = this.oldImgList.map(p => this.baseURI + p);
      //   }
      //   this.imageDrawerVisible = true;
      // },
      let screenshotArr = [];
      if (row.screenshot) {
        if (Array.isArray(row.screenshot)) {
          screenshotArr = row.screenshot;
        } else if (typeof row.screenshot === 'string') {
          screenshotArr = row.screenshot.split(",").filter(item => item);
        }
      }
      this.oldImgList = screenshotArr;
      this.previewImages = this.oldImgList.map(p => this.baseURI + p);

      this.imageDrawerVisible = true;
    },

    exportExcel() {
      if (!this.tstPlan.id) {
        this.$utils.msg.warning("请选择测试计划");
        return;
      }

      const fullUrl = this.baseURI + "/tst/testcase/export";

      this.$axios({
        url: fullUrl,
        method: "get",
        params: {
          planId: this.tstPlan.id
        },
        responseType: "blob"
      }).then(res => {
        // 关键：判断响应类型，如果是JSON（说明是错误信息），就不生成文件
        const contentType = res.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          // 解析错误信息并提示
          const reader = new FileReader();
          reader.onload = function () {
            const errorMsg = JSON.parse(reader.result);
            this.$utils.msg.warning("导出失败：" + (errorMsg.msg || "未知错误"));
          }.bind(this);
          reader.readAsText(new Blob([res.data]));
          return;
        }

        // 只有响应是Excel类型时，才执行下载
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "测试用例.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$utils.msg.success("导出成功！");
      }).catch(err => {
        this.$utils.msg.warning("导出失败：" + (err.response?.data?.msg || "网络错误"));
        console.error("导出错误：", err);
      });
    },

    // 选择文件（base64 模式）
    onFileSelect(base64) {
      if (!base64) return;
      this.previewImages.push(base64);
    },

    async deleteImg(idx) {
      // 拿到要删除的路径
      let delPath = this.oldImgList[idx];

      // 先删界面
      this.previewImages.splice(idx, 1);
      this.oldImgList.splice(idx, 1);

      if (!delPath) {
        return;
      }

      try {
        // 正确传参！！！
        await this.$axios.post(this.baseURI + "/components/uploadComponent/deleteFile", {
          path: delPath
        });
        this.$utils.msg.success("图片已从服务器删除");
      } catch (e) {
        this.$utils.msg.warning("删除失败");
      }
    },

    // 取消
    handleCancel() {
      this.imageDrawerVisible = false;
    },

    // 保存时自动删除废弃图片
    async saveImgsToRow() {
      if (!this.currentRow) {
        this.$utils.msg.warning("未选择当前测试用例行！");
        return;
      }

      try {
        let newPaths = [];
        let addImages = this.previewImages.slice(this.oldImgList.length);

        // 上传新图片
        for (let base64 of addImages) {
          let blob = await fetch(base64).then(res => res.blob());
          let file = new File([blob], "image.png", { type: blob.type });

          let formData = new FormData();
          formData.append("file", file);
          formData.append("model", "fileSystem");
          formData.append("uri", "/statics/tst");

          let res = await this.$axios.post(
            this.baseURI + "/components/uploadComponent/fileUpload",
            formData,
            { headers: { jwttoken: this.$caches.token.get() } }
          );

          if (res.code === this.$constant.response.code.success) {
            let fullUrl = res.data;
            let path = fullUrl.includes("/scrum/") ? "/" + fullUrl.split("/scrum/")[1] : fullUrl;
            newPaths.push(path);
          }
        }

        // 最终图片 = 保留的旧图 + 新图
        let allImages = [...this.oldImgList, ...newPaths];
        this.currentRow.screenshot = allImages.join(",");

        this.$utils.msg.success("图片保存成功！");
        this.imageDrawerVisible = false;

      } catch (err) {
        this.$utils.msg.warning("图片上传失败！");
        console.error("上传错误：", err);
      }
    },

    // 加载用例
    loadTestCases() {
      if (!this.tstPlan.id) {
        this.subjects = [];
        return;
      }

        // 先试着加载草稿
  const hasDraft = this.loadDraft();
    if (hasDraft) {
    console.log('已加载本地草稿');
    return;  // 有草稿就不调接口了
  }
    // 没有草稿 → 从后端加载
  this.loadingFlag = true;  // 防止触发倒计时

      api.listApi({ planId: this.tstPlan.id }, (res) => {

        console.log("用例列表：", res.data);
        let arr = res.data.records ? res.data.records : [];
        // arr.forEach(v => {
        //   if (v.screenshot && v.screenshot.length > 10) {
        //     v.screenshot = JSON.parse(v.screenshot)
        //   }
        // })
        arr.forEach(v => {
          if (v.screenshot && typeof v.screenshot === 'string' && v.screenshot.length > 10) {
            try {
              // 字符串解析为JSON
              const parsed = JSON.parse(v.screenshot);
              if (Array.isArray(parsed)) {
                v.screenshot = parsed;
              }
            } catch (e) {

            }
          }
        });


        this.subjects = arr
         this.loadingFlag = false;  // 加载完关闭 flag
      });



    },

    open(parameter, title, disabled) {
      this.tstPlan = parameter;

      this.notEdit = true
      this.toEditTxt = "维护用例"
      if (parameter.charMean) {
        try {
          let arr = JSON.parse(parameter.charMean);
          this.charMeanOptions = arr.map(item => ({
            char: (item.char || item[' char'] || '').trim(),
            mean: (item.mean || item[' mean'] || '').trim()
          }));

          //默认初始值
          if (this.charMeanOptions.length > 0) {
            this.charMean = this.charMeanOptions[0].char
          }

        } catch (e) {
          this.charMeanOptions = [];
        }
      }

      this.loadTestCases();

      this.disabled = disabled;
      this.$refs.popup.open(title, "80%");
    },

    close() {

        this.stopCountdown();  // 清定时器
      this.$refs.popup.close();
    },

    async toEditSubs() {
      if (this.notEdit) {
        this.subjectsBackup = JSON.parse(JSON.stringify(this.subjects));
        this.notEdit = false;
        this.toEditTxt = "取消维护";
      } else {
        let changed = JSON.stringify(this.subjects) !== JSON.stringify(this.subjectsBackup);
        if (changed) {
          await this.$confirm("数据已修改，是否保存？", "提示").catch(() => {
            this.subjects = JSON.parse(JSON.stringify(this.subjectsBackup));
            this.$nextTick(() => {
            this.saveDraft();  // 立即把回退后的内容存草稿
            });

            this.notEdit = true;
            this.toEditTxt = "维护用例";
            return new Promise(() => { });
          });
          this.submit();
        }
        this.notEdit = true;
        this.toEditTxt = "维护用例";
      }
    },

    toAddSubs() {
      if (!this.subjects) this.subjects = [];
      let newNo = "T-01";
      if (this.subjects.length > 0) {
        let last = this.subjects[this.subjects.length - 1].caseno || "";
        let match = last.match(/(\d+)$/);
        if (match) {
          newNo = last.replace(/\d+$/, "") + (Number(match[1]) + 1).toString().padStart(2, '0');
        }
      }
      this.subjects.push({
        caseno: newNo,
        title: "",
        module: "",
        state: "",
        preconditions: "",
        executeData: "",
        executionSteps: "",
        expectedResult: "",
        actualResult: "",
        screenshot: "",
        planid: this.tstPlan.id
      });
    },

    delSub(idx) {
      // 获取当前要删除的行
      const row = this.subjects[idx];

      // 如果是新增未保存的数据（没有id），直接删除前端即可
      if (!row.id) {
        this.subjects.splice(idx, 1);
        return;
      }

      // 已保存到数据库的数据 → 调用后端删除接口
      this.$utils.confirm.warning("提示", "确定删除？", () => {
        // 调用你真实的删除接口
        api.removeApi({ ids: row.id }, () => {
          // 删除成功：删除页面数据
          this.subjects.splice(idx, 1);
          this.$utils.msg.success("删除成功");
        }, (err) => {
          this.$utils.msg.warning("删除失败：" + (err || "接口异常"));
        });
      });
    },

    submit() {
      this.$utils.confirm.warning("提示", "确定保存？", () => {
        let data = this.subjects.map(i => ({ ...i, planId: this.tstPlan.id }));
        api.mergeApi(data, () => {
          this.$utils.msg.success("保存成功");
          this.notEdit = true;
          this.toEditTxt = "维护用例";
          this.stopCountdown();  // 清定时器
          this.$parent.list();
        });
      });
    },

    // 状态查询
    list() {
      // 重新查询用例，传递 status 参数
      const params = { planId: this.tstPlan.id, status: this.status };
      api.listApi(params, (res) => {
        const data = res.data?.records || res.data || [];
        // 为每条数据添加 checked 属性
        this.subjects = data.map(item => ({
          ...item,
          checked: false
        }));
      });
    },

    // 全选/取消全选
    allchoose() {
      if (!this.subjects || this.subjects.length === 0) {
        return;
      }

      // 检查是否已经全部选中
      const allChecked = this.subjects.every(item => item.checked);

      // 如果全部选中，则取消全选；否则全选
      const newStatus = !allChecked;
      this.subjects.forEach(item => {
        this.$set(item, 'checked', newStatus);
      });
    },

    // 生成Sprint待办
    toaddsprint() {
      //通过父组件的row.dbColumn_productid查询Sprint
      api.getspringbynameApi({ productId: this.tstPlan.dbColumn_productid }, (res) => {
        const data = res.data?.records || res.data || [];
        // 如果有数据，打开弹窗显示Sprint选择界面
        if (data.length > 0) {
          this.sprintList = data;
          this.sprintForm.sprintId = '';
          this.$refs.sprintDialog.open('选择Sprint', '40%');
        } else {
          this.$utils.msg.warning("未找到相关的Sprint");
        }
      })
    },

    // 关闭Sprint选择弹窗
    closeSprintDialog() {
      this.$refs.sprintDialog.close();
      this.sprintForm = '';
      this.selectProd = ''
    },

    // 确认选择Sprint
    confirmSprint() {
      let params = {};
      let SprintName = "";
      let ProName = "";

      // 验证是否选择了Sprint
      if (!this.sprintForm.sprintId) {
        this.$utils.msg.warning("请选择一个Sprint");
        return;
      }
      this.sprintId = this.sprintForm.sprintId;
      // 获取选中的 sprint 信息
      const selectedSprint = this.sprintList.find(item => item.id === this.sprintForm.sprintId);
      if (selectedSprint) {
        SprintName = selectedSprint.name || "";

        // 兼容两种命名方式：驼峰和下划线
        params.startTime = selectedSprint.startTime
        params.endTime = selectedSprint.endTime

      } else {
        console.warn('未找到选中的 Sprint');
        this.$utils.msg.warning("未找到选中的Sprint");
        return;
      }

      //获得产品信息
      api.getproductidApi({ productId: this.tstPlan.dbColumn_productid }, (res) => {
        // 处理返回的产品数据
        const product = res.data?.records || res.data;

        if (product && product.id) {
          this.selectProd = product.id;
          ProName = product.name || '';

        } else {
          console.warn('未获取到有效的产品信息');
          this.$utils.msg.warning('未获取到产品信息');
          return;
        }

        // 获取产品下的团队成员
        if (this.selectProd) {
          // 将 sprintId 存储到 localStorage，供 getTMemberBySprId API 使用
          localStorage.setItem("sprintId", this.sprintForm.sprintId);

          apiTeamMember.getTMemberBySprId(true, (response) => {
            if (response && response.data) {
              params.teamAndMember = response.data;
            } else {
              console.warn('获取团队成员数据为空');
            }

            // 计算hasArriHopegs（在获取团队成员后执行）
            if (selectedSprint && selectedSprint.allManDay !== undefined) {
              // 调用 API 获取当前 Sprint 的所有待办任务，计算已分配工时
              apiSprintBacklog.list({ sprid: this.sprintForm.sprintId }, (backlogResponse) => {
                let allPlaned = 0;

                // 遍历所有待办任务，累加预计工时（与 list.vue 中的逻辑一致）
                if (backlogResponse.data && backlogResponse.data.list) {
                  backlogResponse.data.list.forEach(v => {
                    allPlaned += v.hopegs * 1;  // 乘以 1 确保是数字类型
                  });
                }

                // 计算剩余可分配工时：总人天数 × 8 - 已分配工时
                params.hasArriHopegs = Math.max(0, selectedSprint.allManDay * 8 - allPlaned);

              }, (error) => {
                console.error('获取 Sprint 待办列表失败:', error);
                // 如果获取失败，默认设置为 0
                params.hasArriHopegs = Math.max(0, selectedSprint.allManDay * 8);
              });

              // 打开窗口
              this.$refs.edit.open(
                params,
                "添加执行待办: " + SprintName + " @ " + ProName,
                true
              );

            } else {
              console.warn('未找到选中的 Sprint ');
              params.hasArriHopegs = 0;
              return;
            }

          }, (error) => {
            console.error('获取团队成员失败:', error);
            this.$utils.msg.warning('获取团队成员信息失败');
          });
        }
      })
      console.log("父亲", params)
    },

    //成功了将选中的state改为2
    handleSuccess() {
      // 遍历 subjects 数组，将所有选中（checked === true）的测试用例的 state 改为 2
      let hasCheckedItems = false;
      this.subjects.forEach(item => {
        if (item.checked === true) {
          item.state = 2;  // 将状态改为 2
          hasCheckedItems = true;
        }
      });

      // 只有在有选中项时才调用API保存
      if (hasCheckedItems && this.tstPlan.id) {
        // 按照后端期望的格式：直接的数组，每个元素包含planId
        const data = this.subjects.map(i => ({ ...i, planId: this.tstPlan.id }));

        api.mergeApi(data, () => {
          this.$utils.msg.success("保存成功");
          this.notEdit = true;
          this.toEditTxt = "维护用例";
          // 重新加载测试用例数据，确保显示最新的状态
          this.list();
          // 刷新父组件列表
          // this.$parent.list();
          // 关闭Sprint选择弹窗
          this.closeSprintDialog();
        });
      }
    },
   // 用户输入 → 启动倒计时（只启动一次）
  onUserInput() {
    // 加载数据时不触发
    if (this.loadingFlag) return;
    
    // 只在编辑状态触发
    if (this.notEdit) return;
    
    // 已启动 → 不重复启动
    if (this.countdownStarted) return;
    
    this.startCountdown();
  },

  // 启动倒计时
  startCountdown() {
    this.countdownStarted = true;
    this.countdown = this.circleTotal;
    this.countdownVisible = true;
    
    // 先清掉可能存在的旧定时器
    if (this.autoSaveTimer) {
      clearInterval(this.autoSaveTimer);
    }
    
    this.autoSaveTimer = setInterval(() => {
      this.countdown--;
      
      if (this.countdown <= 0) {
        // 30 秒到了 → 保存 + 提示 + 重置
        this.saveDraft();
        this.$utils.msg.success("已自动保存");
        
        // 继续循环（重置倒计时）
        this.countdown = this.circleTotal;
      }
    }, 1000);
  },

  // 停止倒计时
  stopCountdown() {
    if (this.autoSaveTimer) {
      clearInterval(this.autoSaveTimer);
      this.autoSaveTimer = null;
    }
    this.countdownStarted = false;
    this.countdownVisible = false;
    this.countdown = this.circleTotal;
  },

  // 保存草稿到 sessionStorage
  saveDraft() {
    const key = `case_draft_${this.tstPlan.id}`;
    const draft = {
      subjects: this.subjects,
      savedAt: new Date().toISOString()
    };
    sessionStorage.setItem(key, JSON.stringify(draft));
  },

  // 加载草稿
  loadDraft() {
    const key = `case_draft_${this.tstPlan.id}`;
    const raw = sessionStorage.getItem(key);
    if (!raw) return false;
    
    try {
      const draft = JSON.parse(raw);
      if (draft && draft.subjects && Array.isArray(draft.subjects)) {
        this.subjects = draft.subjects;
        return true;
      }
    } catch (e) {
      console.warn('解析草稿失败', e);
    }
    return false;
  },

  // 清草稿
  clearDraft() {
    const key = `case_draft_${this.tstPlan.id}`;
    sessionStorage.removeItem(key);
  },  

// 手动暂存
manualSaveDraft() {
  this.saveDraft();
  this.$utils.msg.success("已暂存");
  
  // 可选：点击暂存后重置倒计时（相当于重新开始 30s）
  this.countdown = this.circleTotal;
},


},

//清理定时器
beforeDestroy() {
  this.stopCountdown();
},

};

</script>

<style lang="scss" scoped>
@import "~common/custom/css/common.scss";
.autosave-wrapper {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  padding: 8px 16px;
  border-radius: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);

  .autosave-circle {
    position: relative;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      position: absolute;
      top: 0;
      left: 0;
    }

    .autosave-text {
      position: relative;
      font-size: 14px;
      color: #409EFF;
      font-weight: bold;
    }
  }
}

</style>